import {
  composeValidations,
  pathAvailableValidation,
  pathValidation,
} from './common.js';

export function createDashboardPluginValidation(projectFolder: string) {
  return composeValidations([
    [
      pathAvailableValidation(projectFolder),
      'The plugin folder must be unique, please choose a name that has not been used yet in your application.',
    ],
    [
      pathValidation,
      'The plugin folder must be a valid path ([a-z0-9-/]+) and must not start with a dot.',
    ],
  ]);
}
